import styled from "styled-components";
import Select from 'react-select';

export default styled(Select)`
  .Select__control {
    height: 0%;  /* Cabirka dhererka */
    width: 100%;    /* Si loo hubiyo in control-ka uu qaato dhammaan booska */
    border: 1px solid  #000000; /* Border default */
    padding: 0px;  /* Remove any padding */
    margin: 7px 0px; /* Margin si looga dhigo in borders-ka uusan isku xidhmin */
    border-radius: 30px;
    cursor: pointer;
    color: #000000;
    background: transparent;

    /* Si aad u hubiso in borders-ku ay ku dheggan yihiin */
    display: flex; /* Flexbox si ay u noqoto horizontally aligned */
    align-items: center; /* Center items vertically */
    justify-content: space-between; /* Ensure the text and indicator are spaced correctly */
  }

  

  .Select__single-value {
    font-size: 13px;
    color: #000000;
    margin-left: 10px; /* Optional: to add a bit of spacing between text and the left edge */
  }

  .Select__control:hover {
    border-color: #000000; /* Border color on hover */
  }

  .Select__control--is-focused {
    box-shadow: none;
    outline: none;
  }

  /* Arrow indicator color (downward arrow) */
  .Select__indicator {
    color: #000000; /* Default color of the arrow */
    transition: color 0.3s ease; /* Smooth transition for color change */
    size: 0px;
  }

  .Select__control:hover .Select__indicator {
    color: rgb(0, 0, 0); /* Change arrow color when hovering over control */
  }

  /* Active (focused) arrow indicator color */
  .Select__control--is-focused .Select__indicator {
    color: rgb(0, 0, 0); /* Color for the arrow when the select is focused */
  }

  /* Indicator Separator (line between the arrow and the control) */
  .Select__indicator-separator {
    display: block; /* Display the separator */
    width: 1px;
    background-color: rgb(0, 0, 0); /* Default color for the separator */
    margin: 0px;
  }

  /* Menu Style */
  .Select__menu {
    color: ${({ theme }) => theme.text};
    background: ${({ theme }) => theme.background};
    border: 1px solid ${({ theme }) => theme.text};
    font-size: 12px;
    border-radius: 15px;
  }

  /* Scrollbar style */
  .Select__menu-list::-webkit-scrollbar {
    width: 4px;
  }
  .Select__menu-list::-webkit-scrollbar-track {
    background: transparent;
  }
  .Select__menu-list::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.text};
  }

  /* Focused Option Style */
  .Select__option--is-focused {
    color: ${({ theme }) => theme.text};
    background: ${({ theme }) => theme.background};
    border-radius: 15px;
  }

  /* Selected Option Style */
  .Select__option--is-selected {
    color: ${({ theme }) => theme.text};
    background: ${({ theme }) => theme.background};
    border-radius: 15px;
  }
`;
